import { Button } from "@material-ui/core"
import { trackMenuClicks } from "common/analytics"
import NextLink from "common/bit/NextLink"
import { Desktop, Mobile } from "common/MediaQueries"
import { HeaderTopButtonsLinks } from "common/SiteLinks"
import React from "react"
import styled from "styled-components"
import colors from "theme/colors"

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-inline-start: auto;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-inline-start: 0;
    justify-content: flex-start;
    gap: 10px;
    width: 100%;
    padding: 15px 20px;
  }
`

const StyledButton = styled(Button)`
  background-color: ${colors.white};
  color: ${colors.black};
  border-radius: 3px;
  margin-left: 10px;
  border: none;
  &:hover {
    border: none;
  }
  text-transform: none;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-left: 0;
    padding: 5px 10px;
    min-width: auto;
  }
`

// Custom styled Button with outlinedSecondary styles
const OutlinedSecondaryButton = styled(Button)`
  &.outlined-secondary {
    min-width: 120px;
    font-size: 16px;
    width: fit-content;
    color: #ffffff;
    background-color: transparent;
    border: 2px solid #ffffff;
    padding: 11.5px 13px;
    text-transform: none;
    &:hover {
      box-shadow: none;
      background-color: #d5d5d5 !important;
      color: #101010;
      border: 2px solid #d5d5d5;
    }
    ${(p) => p.theme.breakpoints.down("sm")} {
      padding: 7px 10px;
    }
  }
`

type Props = {
  closeDrawer?: (event: React.KeyboardEvent | React.MouseEvent) => void
  setSubLinks?: any
}

const HeaderTopButtons: React.FC<Props> = ({ closeDrawer, setSubLinks }) => {
  return (
    <StyledWrapper>
      <NextLink
        href={HeaderTopButtonsLinks[0].link}
        openInNewTab={HeaderTopButtonsLinks[0].blank}
      >
        <OutlinedSecondaryButton
          variant="outlined"
          className="outlined-secondary"
          onClick={(e) => {
            setSubLinks?.(null)
            trackMenuClicks()
            closeDrawer?.(e)
          }}
          tabIndex={-1}
          role="presentation"
        >
          {HeaderTopButtonsLinks[0].title}
        </OutlinedSecondaryButton>
      </NextLink>
      <NextLink
        href={HeaderTopButtonsLinks[1].link}
        openInNewTab={HeaderTopButtonsLinks[1].blank}
      >
        <Desktop aboveTheFold>
          <StyledButton
            onClick={(e) => {
              setSubLinks?.(null)
              trackMenuClicks()
              closeDrawer?.(e)
            }}
            tabIndex={-1}
            role="presentation"
          >
            {HeaderTopButtonsLinks[1].title}
          </StyledButton>
        </Desktop>
        <Mobile>
          <OutlinedSecondaryButton
            variant="outlined"
            className="outlined-secondary"
            onClick={(e) => {
              setSubLinks?.(null)
              trackMenuClicks()
              closeDrawer?.(e)
            }}
            tabIndex={-1}
            role="presentation"
          >
            {HeaderTopButtonsLinks[1].title}
          </OutlinedSecondaryButton>
        </Mobile>
      </NextLink>
    </StyledWrapper>
  )
}

export default HeaderTopButtons
